export default __webpack_public_path__ + "static/media/z.f9ea669f.jfif";